import { render, staticRenderFns } from "./NftSearch.vue?vue&type=template&id=10785548"
import script from "./NftSearch.vue?vue&type=script&lang=js"
export * from "./NftSearch.vue?vue&type=script&lang=js"
import style0 from "./NftSearch.vue?vue&type=style&index=0&id=10785548&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports